// import "@vite/client";
// /* eslint-disable no-undef */
const AG_LICENSE = __AG_LICENSE__;
if(agGrid) agGrid.LicenseManager.setLicenseKey(AG_LICENSE);
